import CompanySVG from "./svg/companies.svg?react";

const CompanyBadge = ({ style, className = "", ...props }) => (
  <span className={`record-badge companies ${className}`} style={style} aria-hidden="true">
    <CompanySVG {...props} />
  </span>
);

export default CompanyBadge;
